const faq = [
  {
    id: "faq1",
    icon1: "bi bi-chevron-down icon-show",
    icons2: "bi bi-chevron-up icon-close",
    qns: "Is it easy to use?",
    href: "#faq1",
    ans: "The UI of Campus Selection System is user friendly and is designed in such a way that you can easily use it without having any pressure on mind.",
  },
  {
    id: "faq2",
    icon1: "bi bi-chevron-down icon-show",
    icons2: "bi bi-chevron-up icon-close",
    qns: "How to use website?",
    href: "#faq2",
    ans: "You have to create an account from your MS team id. then after logging in , you have to fill your information in profile section and upload your resume. On your home page you can see the companies that are listed for placements. You can simply apply for that company if your profile fall under the requiremts of company.",
  },
  {
    id: "faq3",
    icon1: "bi bi-chevron-down icon-show",
    icons2: "bi bi-chevron-up icon-close",
    qns: "I don't have MS temas log in id?",
    href: "#faq3",
    ans: "Kindly visit to the college and ask the same for your CC.",
  },
  {
    id: "faq4",
    icon1: "bi bi-chevron-down icon-show",
    icons2: "bi bi-chevron-up icon-close",
    qns: "I am not able to see any company?",
    href: "#faq4",
    ans: "kindly fill all the information correct if your information is found wrong then you won't be able to see any company as your account is disabled by the college.",
  },
  {
    id: "faq5",
    icon1: "bi bi-chevron-down icon-show",
    icons2: "bi bi-chevron-up icon-close",
    qns: "Can i apply for more than one job?",
    href: "#faq5",
    ans: "Yes , you can. But when you get selected in any one of the companies form that moment you are not allow to apply for any of the companies except dream companies like Amazon, Google.",
  },
];

export default faq;

//   const [Qns,AddQns] = useState([
//     {icon1:'bi bi-chevron-down icon-show',icon2:'bi bi-chevron-up icon-close' ,qns:'Non consectetur a erat nam at lectus urna duis?', ans:'Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.',id:"faq1",href:"#faq1"},
//     {icon1:'bi bi-chevron-down icon-show',icon2:'bi bi-chevron-up icon-close' ,qns:'Non consectetur a erat nam at lectus urna duis?', ans:'Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.',id:"faq2",href:"#faq2"},
//     {icon1:'bi bi-chevron-down icon-show',icon2:'bi bi-chevron-up icon-close' ,qns:'Non consectetur a erat nam at lectus urna duis?', ans:'Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.',id:"faq3",href:"#faq3"},
//     {icon1:'bi bi-chevron-down icon-show',icon2:'bi bi-chevron-up icon-close' ,qns:'Non consectetur a erat nam at lectus urna duis?', ans:'Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.',id:"faq4",href:"#faq4"},
//     {icon1:'bi bi-chevron-down icon-show',icon2:'bi bi-chevron-up icon-close' ,qns:'Non consectetur a erat nam at lectus urna duis?', ans:'Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.',id:"faq5",href:"#faq5"},
//     {icon1:'bi bi-chevron-down icon-show',icon2:'bi bi-chevron-up icon-close' ,qns:'Non consectetur a erat nam at lectus urna duis?', ans:'Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.',id:"faq6",href:"#faq6"},
//   ])
